import React from 'react';
import serviceimg from '../../src/images/service/imgsm.png';

const Contact = ({ header }) => {
  return (
    <section
      className="flex flex-col gap-3 items-center justify-center h-[200px] w-full bg-banner overflow-x-hidden"
      id="contact"
    >
      <div className="flex items-center gap-3 justify-center">
        <img src={serviceimg} alt="image of a service logo" />
        <h3 className="text-[#F0FFC5] font-semibold text-md">
          {header?.title || 'CONTACT US'}
        </h3>
      </div>
      <div>
        <h2 className="text-[#FFFF] text-3xl font-bold">
          {header?.subtitle || 'How you can reach us'}
        </h2>
      </div>
    </section>
  );
};

export default Contact;
